<script>
  export default {
    props: {
      tableData: Object,
      customRenderers: Array,
      searchField: String,
      isSelectEnabled: Boolean,
      selectKey: String,
      setPerPage: Number,
      classSeries: String,
      tableID: String,
      headerIsHidden: Boolean,
      isSearch: Boolean,
      itemRowClasses: Function
    },
    data () {
      return {
        item: [],
        items: [],
        search: '',
        singleSelect: false,
        selected: [],
        loading: true,
        headers: [],
        noItemText: 'No data available',
        totalFileCountFromApi: 0,
        totalItemCountFromApi: 0,
        totalRowsFromApi: 0,
        subscriberPageS3Copy: 0,
        pagestopCopy: 0,
        paginationEventValue: {
          itemsLength: 0,
          itemsPerPage: 0,
          page: 0
        },
        options: {
          itemsPerPage: 10
        },
        query: {
          page: 1,
          itemsPerPage: 10,
          q: ""
        },
        showw: false,
        result: []
      }
    },
    async mounted() {
      this.loading = true;
      if(this.tableData.hasOwnProperty('setQuery') && this.tableData.hasOwnProperty('queryValue') ){
        await this.$store.commit(this.tableData.setQuery,  this.tableData.queryValue);
        this.subscriberPageS3Copy = this.tableData.queryValue
      }
      let result = await this.$store.dispatch(this.tableData.dispatchFunction);
   
      this.totalRowsFromApi = result.length
      this.items = result;

      let getQueryData  = await this.$store.getters[this.tableData.getQuery];
  
      this.totalItemCountFromApi = this.tableData.queryValue['totalRowsCount']
      this.totalFileCountFromApi = this.tableData.queryValue['fileEndCount']
      this.loading = false;
      this.$emit("datatableItems", this.items);

      if (this.tableData.hasOwnProperty('noItemText')){
        this.noItemText = this.tableData.noItemText
      }
      this.headers = this.tableData.headers
    },
    computed: {
      // getContent() {
      //   return this.result
      // }
    },
    watch: {
      // getContent(newVal) {
      //   this.items = newVal;
      //   this.loading = false;
      //   this.$emit("datatableItems", this.items);
      // },
      "tableData.headers"(){
        this.headers = this.tableData.headers
      },
      "isSearch"(value){
        this.loading = value
      },
      async "pagestopCopy"(data){
        if (this.pagestopCopy  != 0 &&
            this.pagestopCopy >= this.totalRowsFromApi){
              console.log('----------------- START')
              console.log('-----------------',this.pagestopCopy)
              console.log('-----------------',this.totalRowsFromApi)
          await this.callNextCsvFilePage()
        }
      }
    },
    methods: {
      async callNextCsvFilePage(){
        this.loading = true;
          this.subscriberPageS3Copy['pageFile'] = this.subscriberPageS3Copy['pageFile'] + 1;
          await this.$store.commit(this.tableData.setQuery, this.subscriberPageS3Copy);
          let result = await this.$store.dispatch(this.tableData.dispatchFunction);
          this.items = [...this.items, ...result]; // merged the existing rows and new file row
          this.totalRowsFromApi = this.items.length
          this.loading = false;
          // this.options['page'] = this.options['page'] + 1 // THIS trigger next page
      },
      async paginationEvent(pagination) {
        pagination['itemsLength'] = this.totalItemCountFromApi // set manually the max number of pagination (x of itemsLength)
        this.paginationEventValue = pagination
        this.query.page = this.paginationEventValue.page
        this.query.itemsPerPage = this.paginationEventValue.itemsPerPage
        this.pagestopCopy = pagination.pageStop
      },
      updateSearchField(searcVal){
        this.search = searcVal
      },
      clearSelectedFields(){
        this.selected = []
      },
      // COMMON FUNCTION HERE Emit
      emitSelectedItem(value) {
        let selectCollection = this.selected
        this.$emit("datatableSelectedItem", selectCollection);
      }
    },
  }
</script>

<template>
  <v-data-table  @pagination="paginationEvent" @input="emitSelectedItem()"
    class="custom-datatable"
    v-model="selected"
    :single-select="singleSelect"
    :item-key="selectKey"
    :class="classSeries"
    :id="tableID"
    :headers="headers"
    :items="items"
    :show-select="isSelectEnabled"
    :items-per-page="setPerPage"
    :search="search"
    :loading="loading"
    :hide-default-header="headerIsHidden"
    loading-text="Loading... Please wait"
    :no-data-text="noItemText"
    :item-class="itemRowClasses"
    :footer-props="{'items-per-page-options':[10, 50, 100]}"
    :options.sync="options"
    :page="query.page"
  >
    <template v-slot:loading>
      <slot name="customeLoading">
            <v-progress-circular
            indeterminate
            color="primary"
            ></v-progress-circular>
      </slot> 
    </template>
    <template v-for="slot in this.customRenderers" v-slot:[`item.${slot.field}`]="{ item }">
      <slot v-bind:item="item" :name="`${slot.field}params`"> </slot>
    </template>
  </v-data-table>
</template>
<!-- :footer-props="{'items-per-page-options':[5, 10, 50, 100]}" -->
<style scoped>
.custom-datatable{
  min-height: 500px;
}
</style>